module.exports = __webpack_public_path__ + "static/media/dashboard-pro-call.b87ca7fa.webp";